import { createSelector } from 'reselect';

const getConnectionError = (state) => state?.connectionError?.error || false;

export const getConnectionErrorState = createSelector(
    [getConnectionError],
    (errorStatus) => {
        return {
            errorStatus
        };
    }
);
